<template>
  <div class="confirmCode">
    <button class="goBack" @click="goBack()">
      <i class="fas fa-chevron-left"></i>
      {{ $t("authorization.back") }}
    </button>
    <form @submit.prevent="confirmCode">
      <h1>{{ $t("authorization.verifyTitle") }}</h1>
      <div class="code">
        <input
          v-model="code"
          pattern=".{6,6}"
          required
          type="text"
          :placeholder="$t('authorization.confirmCode')"
        />
        <small v-if="showError">
          {{ $t("authorization.verification_code_invalid") }}
        </small>
        <!-- <button class="send">{{ $t("authorization.repeatCode") }}</button> -->
      </div>
      <button type="submit" class="confirm">
        {{ $t("authorization.confirmCodeBtn") }}
      </button>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  /*  eslint-disable */
  setup(props, { emit }) {
    const testCode = "123456";
    /* eslint-enable */
    const code = ref("");
    const showError = ref(false);

    const confirmCode = () => {
      const confirmationResult = window.confirmationResult;
      if (confirmationResult && code.value.length === 6) {
        confirmationResult
          .confirm(code.value)
          // .confirm(testCode)
          .then(() => {
            emit("submitForm");
          })
          .catch(() => {
            showError.value = true;
          });
      } else {
        showError.value = true;
      }
    };

    const goBack = () => {
      emit("goBack");
    };

    return { confirmCode, code, showError, goBack };
  },
};
</script>

<style lang="scss" scoped>
.confirmCode {
  .goBack {
    color: var(--explanation-color);
    background: transparent;
    font-size: 1.1em;
    line-height: 1.2em;
    margin-left: 2rem;
    margin-top: 1rem;
  }
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    h1 {
      font-size: 1.5em;
      line-height: 1.4em;
      font-weight: 400;
      color: var(--title-color);
      margin-top: 1.9rem;
      margin-bottom: 1.9rem;
      padding-left: 2.4rem;
      padding-right: 2.4rem;
    }
    .code {
      display: flex;
      flex-direction: column;
      width: 21rem;
      input {
        background: var(--input-bg);
        outline: none;
        width: 100%;
        height: 3.4rem;
        padding: 0 1.3rem;
      }
      small {
        grid-area: warning;
        color: var(--warning-danger);
        line-height: 1.2em;
        margin: 0.6rem 0;
      }
      button {
        margin-left: auto;
        background: none;
        outline: none;
        color: var(--light-primary);
        margin-top: 0.313rem;
        cursor: pointer;
        font-size: 1em;
        line-height: 1.1em;
      }
    }
    .confirm {
      width: 16rem;
      height: 3.7rem;
      color: var(--explanation-color);
      border: 2px solid #6c8fba;
      margin-top: 2.5rem;
      margin-bottom: 2rem;
      background: transparent;
      outline: none;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 540px) {
  .confirmCode {
    form {
      h1 {
        padding-left: 1rem;
        padding-right: 1rem;
        margin-top: 1rem;
        font-size: 1.2em;
      }
      .code {
        width: 15.5rem;
        input {
          width: 100%;
        }
      }
      .confirm {
        margin-top: 3.5rem;
      }
    }
  }
}
</style>
